/**
 * Whether a CDN sign-in (`ApiService.loginCdn`) is still in flight. An image request that
 * leaves before the sign-in has set its cookie gets a 403, so the Forge image queue holds its
 * requests until every sign-in in flight has settled (DLI-2542).
 */
let signInsInFlight = 0;
const settledListeners = new Set<() => void>();

/** Track a CDN sign-in until it settles either way; returns the same promise. */
export function trackCdnSignIn<T>(signIn: Promise<T>): Promise<T> {
  signInsInFlight += 1;
  const settle = () => {
    signInsInFlight -= 1;
    if (signInsInFlight === 0) settledListeners.forEach((listener) => listener());
  };
  signIn.then(settle, settle);
  return signIn;
}

export function isCdnSignInPending(): boolean {
  return signInsInFlight > 0;
}

/** Calls the listener each time the last CDN sign-in in flight settles. */
export function onCdnSignInSettled(listener: () => void): () => void {
  settledListeners.add(listener);
  return () => settledListeners.delete(listener);
}
